export default __webpack_public_path__ + "static/media/sports-hockey.dd16822d.png";